
import { server } from '../engine/server'

var BuildingCameras = Class.create({
    cameras: null,
  	initialize: function() {

	},
	getCameras: function(buildingId, callback) {
        var self = this;
		var url = "building/" + buildingId + '/cameras/all';
		var data = server.getData(url,null, true);
		data
		.done(function(response){
            self.cameras = response.data;
			callback(response);
		})
		.fail(function(e){
			console.log(e);
		});
    },
    startPlayer: function(id, callback) {
        var self = this;
		var url = "camera/" + id + "/start";
		var data = server.getData(url, null, true);
		data
		.done(function(response){
            self.cameras = response.data;
			callback(response);
		})
		.fail(function(e){
			console.log(e);
		});
    },
    deleteCamera: function(id, callback) {
		var url = "camera/" + id + "";
		var data = server.getData(url, null, true, "DELETE");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			console.log(e);
		});
    },
    updateCamera: function(id, name, callback) {
        var url = "camera/" + id + "/update";
        const params = {
            name: name
        }
		var data = server.getData(url, params, true, "PUT");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			console.log(e);
		});
    },
    clearAll: function() {
        this.cameras = null;
    }
});

export let buildingCameras = new BuildingCameras();


// WEBPACK FOOTER //
// app/core/controllers/BuildingCameras.js